import { useMemo } from 'react'
import { calcolaDichiarazione } from '@praticheenergia/ad1-engine'
import type { DatiPeriodo, Diagnostica, ModelloDichiarazione, RegolePeriodo } from '@praticheenergia/ad1-engine'

export interface EsitoCalcolo {
  diagnostiche: readonly Diagnostica[]
  modello: ModelloDichiarazione | null
  bloccato: boolean
  erroreMotore: string | null
}

/**
 * Il valore mostrato qui e' indicativo: quello trasmesso lo ricalcola il worker.
 * Una divergenza fra i due significa regole stale nel client.
 */
export function useCalcolo(dati: DatiPeriodo, regole: RegolePeriodo): EsitoCalcolo {
  return useMemo(() => {
    try {
      const { modello, diagnostiche } = calcolaDichiarazione(dati, regole)
      return {
        diagnostiche,
        modello,
        bloccato: diagnostiche.some((d) => d.gravita === 'bloccante'),
        erroreMotore: null,
      }
    } catch (e) {
      return {
        diagnostiche: [],
        modello: null,
        bloccato: false,
        erroreMotore: e instanceof Error ? e.message : 'errore del motore',
      }
    }
  }, [dati, regole])
}
